import { useState } from "react";

import { IconAlertTriangle, IconCopy } from "@tabler/icons";
import { Formik } from "formik";
import { useTheme } from "styled-components";

import { useCreateApiAccountKeyMutation } from "@sso/apis/apiAccountKeys";
import { TextInput } from "@sso/components/Form";
import { FormikTextInput } from "@sso/components/Formik";
import { apiAccountKeyInitialValues, DialogTitle, notificationsMsgs, SnackbarKeys } from "@sso/constant";
import { useAppDispatch, useAppSelector } from "@sso/hooks/useRedux";
import { closeDialog, selectDialog } from "@sso/store/slices/dialog";
import { pushSnackbar } from "@sso/store/slices/snackbar";
import { ApiAccountKeyCreateRequest } from "@sso/types";
import { Button } from "@sso/ui/Button";
import { CustomForm } from "@sso/ui/CustomForm";
import { RowContainer } from "@sso/ui/FlexBox";
import { Typography } from "@sso/ui/Typography";

import { DialogActionButtons, DialogBody, DialogHeader } from "../components";

export const GenetrateApiKeysDialog = () => {
  const { colors } = useTheme();
  const [generateState, setGenerateState] = useState({ newTokenCreated: false, newlyMintedToken: "" });
  const { id } = useAppSelector(selectDialog);
  const [createKey] = useCreateApiAccountKeyMutation();
  const dispatch: any = useAppDispatch();

  const handleCloseDialog = () => {
    dispatch(closeDialog());
  };

  const handleSubmit = async (a: any) => {
    var createRequest: ApiAccountKeyCreateRequest = { ...a, apiAccountId: id };
    var createResponse = await createKey(createRequest).unwrap();
    setGenerateState({ newTokenCreated: true, newlyMintedToken: createResponse.token });
  };

  const handleAccessTokenCopyClick = () => {
    navigator.clipboard.writeText(generateState.newlyMintedToken);
    dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.API_ACCOUNT_KEY_TOKEN_COPY }));
  };

  const renderCreateForm = () => {
    var expiryMinVal = new Date();
    expiryMinVal.setDate(expiryMinVal.getDate() + 2);

    return <>
      <p>Fill out this form to generate a new access token for this API account.</p>
      <br /><br />
      <Formik
        onSubmit={handleSubmit}
        initialValues={apiAccountKeyInitialValues}
      ><CustomForm width="100%">
          <>
            <FormikTextInput type="date" min={expiryMinVal.toISOString().split('T')[0]} name={"expiryDate"} label="Expiry Date" />
            <FormikTextInput maxLength={100} name={"descriptor"} label="Token Description" />
            <DialogActionButtons buttonTitle={"Create Token"} />
          </>
        </CustomForm>
      </Formik>
    </>;
  };

  const renderTokenCreated = () => {
    return <>
      <RowContainer padding="1rem" margin="0 0.5rem 1rem" bgColor="#fbdcc7" rounded>
        <IconAlertTriangle size="35" color={colors.warning.dark} />
        <Typography size="0.9rem" margin="0 0.5rem" textAlign="left">
          Warning - Make sure you copy the token now. We don't store it and you will not be able to see it
          again.
        </Typography>
      </RowContainer>
      <TextInput
        value={generateState.newlyMintedToken}
        label="Access Token"
        readOnly
        EndIcon={IconCopy}
        onClickEndIcon={handleAccessTokenCopyClick}
      /><RowContainer position="relative" width="100%" padding="0.5rem 0" justify="flex-end">
        <Button variant="text" padding="0.5rem" onClick={handleCloseDialog}>
          Done
        </Button></RowContainer>
    </>;
  };

  return (
    <>
      <DialogHeader title={DialogTitle.GENERATE_API_KEYS} />
      <DialogBody minHeight="150px">
        {!generateState.newTokenCreated && renderCreateForm()}
        {generateState.newTokenCreated && renderTokenCreated()}
      </DialogBody>
    </>
  );
};
